import {environment} from "../../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const WarehouseApiResources = {
  list:  createUrl('warehouses'),
  create:  createUrl('warehouses/create'),
  search:  createUrl('warehouses/search'),
  detail:  createUrl('warehouses'),
  update:  createUrl('warehouses'),
  delete:  createUrl('warehouses'),
  deleteMultiple:  createUrl('warehouses/delete/multiple'),
  deleteAvailability:  createUrl('warehouses/delete/availability'),
  changeStatus: createUrl('warehouses/change/status'),
  copy: createUrl('warehouses/copy'),
  downloadSample:  createUrl('warehouses/import/sample'),
  uploadImport:  createUrl('warehouses/import/upload'),
  validateImport:  createUrl('warehouses/import/validate'),
  executeImport:  createUrl('warehouses/import/execute'),
  importHistory:  createUrl('import-history'),
  // Receiving Tab — Dock Capacity (Flow 1) + Lane View data (Flow 2)
  docksCapacity: createUrl('warehouses'), // /{warehouseId}/docks/capacity
  // Zone Management
  zoneTemplates: createUrl('warehouse/zones/templates'),
  zones: createUrl('warehouses'), // /{warehouseId}/zones
  zonesVisual: createUrl('warehouses'), // /{warehouseId}/zones/visual
  zoneDetail: createUrl('zones'), // /{id}
  createZone: createUrl('warehouses'), // /{warehouseId}/zones
  updateZone: createUrl('zones'), // /{id}
  deleteZone: createUrl('zones'), // /{id}
  slotDetail: createUrl('zones'), // /{zoneId}/slots/{slotId}
  // Floor Management
  floors: createUrl('warehouses'), // /{warehouseId}/floors
  floorSearch: createUrl('warehouse/floors/search'),
  floorFindOrCreate: createUrl('warehouse/floors/find-or-create'),
  // Inventory Management
  inventory: createUrl('warehouse/inventory'),
  inventoryCreate: createUrl('warehouse/inventory'),
  inventoryDetail: createUrl('warehouse/inventory'), // /{id}
  inventoryUpdate: createUrl('warehouse/inventory'), // /{id}
  inventoryDelete: createUrl('warehouse/inventory'), // /{id}
  inventoryLowStock: createUrl('warehouse/inventory/low-stock'),
  inventoryAdjust: createUrl('warehouse/inventory'), // /{id}/adjust
  inventoryReserve: createUrl('warehouse/inventory/reserve'),
  inventoryMaterialLocations: createUrl('warehouse/inventory/material'), // /{materialId}/locations (FLOW 8)
  // FLOW 11: Cycle Counting
  inventoryBinItems: createUrl('warehouse/inventory/bin/items'),
  inventoryCycleCount: createUrl('warehouse/inventory/cycle-count'),
  // FLOW 12: Reservations Management
  inventoryReservations: createUrl('warehouse/inventory'), // /{id}/reservations
  // FLOW 13: Batch/Lot Tracking
  inventoryBatches: createUrl('warehouse/inventory/material'), // /{materialId}/batches
  // Product Search
  productSearch: createUrl('products/search'),
  productList: createUrl('products'),
};
